<template>
    <div class="msg">
        <div class="uikit-col">
            <p>When you see this symbol <img :src="mfeIcon" alt="Event Symbol"> you can book appointments</p>
        </div>
    </div>
</template>

<script>
import Icons from '../utils/icons';

export default {
    computed: {
        mfeIcon () {
            return Icons.getPath('FITTING', 'label');
        }
    }
};
</script>

<style scoped>
.msg {
    padding-top: 8px;
    padding-bottom: 8px;
}
.msg p {
    text-align: center;
    display: flex;
    margin: 20px auto;
    justify-content: center;
    align-items: center;
}
.msg img {
    width: 40px;
    display: inline-block;
    position: relative;
    padding-left: 8px;
    padding-right: 8px;
}
</style>
